import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import TabbedPage from 'tio-employee/components/landing/tabbed-page';
import type { TabbedPageTab } from 'tio-employee/components/landing/tabbed-page';
import { PhChatsCircle, PhChalkboardTeacher } from 'ember-phosphor-icons';
import type IntlService from 'ember-intl/services/intl';

const ROUTE_PREFIX = 'authenticated.repaying-student-debt.coaching';

export default class CoachingPage extends Component {
  @service declare intl: IntlService;

  get tabs(): TabbedPageTab[] {
    return [
      {
        id: 'about',
        label: this.intl.t('coaching.about.tab_title'),
        route: `${ROUTE_PREFIX}.index`,
      },
      {
        id: 'schedule',
        label: this.intl.t('coaching.schedule_time.tab_title'),
        route: `${ROUTE_PREFIX}.schedule`,
      },
    ];
  }

  <template>
    <TabbedPage
      @icon={{PhChatsCircle}}
      @title={{t "coaching.about.how_can_we_help_q"}}
      @subtitle={{t "coaching.about.how_can_we_help_a"}}
      @sectionIcon={{PhChalkboardTeacher}}
      @sectionTitle={{t "coaching.student_loan_coaches"}}
      @tabs={{this.tabs}}
    >
      {{outlet}}
    </TabbedPage>
  </template>
}
